/**
 * Who answers what rules leave open (ORGU-81), for Settings, Approvals: the caption for each
 * choice and the save, live or demo. A hub without the setting reads as People: its requests wait
 * for a person, as before.
 */
import type { ApprovalAnswerer, ApprovalAnswererSetting, ApprovalsState } from '@orgus/protocol';
import { api } from '../../lib/api.ts';
import { useOrgus } from '../../lib/store.ts';

/** One line under the choice: what happens to a request no rule decides. */
export const ANSWERER_CAPTION: Record<ApprovalAnswerer, string> = {
  orgus: 'Orgus allows routine work inside a session’s own folder and declines the rest with a reason. Missions decide for themselves. Ask rules you write still ask you.',
  people: 'Requests no rule decides, and missions’ questions, wait for a person in the Inbox.',
};

/** The hub's answerer, or null when the hub does not have the setting. */
export function answererOf(state: Pick<ApprovalsState, 'answerer'> | null | undefined): ApprovalAnswerer | null {
  return state?.answerer?.answerer ?? null;
}

export async function saveAnswerer(answerer: ApprovalAnswerer): Promise<ApprovalAnswererSetting> {
  const st = useOrgus.getState();
  const cur = st.ext.approvals as ApprovalsState | undefined;
  if (st.mode === 'mock' && cur) {
    await new Promise((r) => setTimeout(r, 200));
    const saved: ApprovalAnswererSetting = { answerer, updatedBy: 'you', updatedAt: Date.now() };
    st.applyExt({ ext: 'approvals', type: 'state', data: { ...cur, answerer: saved } satisfies ApprovalsState });
    return saved;
  }
  const saved = await api<ApprovalAnswererSetting>('/api/approvals/answerer', { method: 'PUT', body: { answerer } });
  const now = useOrgus.getState().ext.approvals as ApprovalsState | undefined;
  if (now) useOrgus.getState().applyExt({ ext: 'approvals', type: 'state', data: { ...now, answerer: saved } satisfies ApprovalsState });
  return saved;
}
